<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Logo from 'next/icon/Logo.vue';
import { useUISettings } from 'dashboard/composables/useUISettings';

// Aviso único sobre o layout novo. A marca de "já vi" fica nas preferências
// do usuário (servidor), então vale em qualquer navegador ou aparelho.
const SEEN_KEY = 'layout_camadas_announcement_seen';

const { t } = useI18n();
const { uiSettings, updateUISettings } = useUISettings();
const dialogRef = ref(null);
let opened = false;

const markAsSeen = () => {
  if (uiSettings.value?.[SEEN_KEY]) return;
  updateUISettings({ [SEEN_KEY]: true });
};

watch(
  uiSettings,
  settings => {
    // As preferências chegam com o perfil; só decide depois de carregadas.
    if (opened || !settings || !Object.keys(settings).length) return;
    if (settings[SEEN_KEY]) return;
    opened = true;
    setTimeout(() => dialogRef.value?.open(), 800);
  },
  { immediate: true }
);
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="t('LAYOUT_ANNOUNCEMENT.TITLE')"
    :confirm-button-label="t('LAYOUT_ANNOUNCEMENT.CONFIRM')"
    :show-cancel-button="false"
    @confirm="dialogRef?.close()"
    @close="markAsSeen"
  >
    <template #description>
      <div class="flex flex-col gap-3 text-sm text-n-slate-11">
        <Logo class="size-12 mb-1" />
        <p class="mb-0">{{ t('LAYOUT_ANNOUNCEMENT.BODY_1') }}</p>
        <p class="mb-0 font-medium text-n-slate-12">
          {{ t('LAYOUT_ANNOUNCEMENT.BODY_2') }}
        </p>
        <p class="mb-0">{{ t('LAYOUT_ANNOUNCEMENT.BODY_3') }}</p>
      </div>
    </template>
  </Dialog>
</template>
